export const densePage = `title: Life Expectancy at Birth by Region, 1950-2023
Global life expectancy rose from 46.5 years in 1950 to 73.2 in 2023, driven primarily by reductions in infant mortality. Sub-Saharan Africa's progress was reversed by HIV/AIDS, which cut life expectancy by 7 years between 1990 and 2003. Source: UN World Population Prospects, 2024 revision.

---
columnTitle: Region
columnTitle: 1950
columnTitle: 1980
columnTitle: 2000
columnTitle: 2023
---
East Asia
45
65
71
78
---
South Asia
37
54
63
72
---
Europe
63
72
74
79
---
Latin America
51
64
71
76
---
North America
68
74
77
79
---
Sub-Saharan Africa
36
48
50
62
-->
`;
